export default "__VITE_ASSET__cMySWfSZ__"